import { render, staticRenderFns } from "./voc-list.vue?vue&type=template&id=65e4ed8c&scoped=true&"
import script from "./voc-list.vue?vue&type=script&lang=js&"
export * from "./voc-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e4ed8c",
  null
  
)

export default component.exports